import type { Asset, AssetGroup, AssetType, Scene } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

function getAssetTypeForCopy(asset: Asset) {
    if (VideoData.isAssetGroup(asset)) {
        return VideoData.GROUP_ASSET_TYPE;
    }
    if (VideoData.isTextAsset(asset)) {
        return VideoData.TEXT_ASSET_TYPE;
    }
    if (VideoData.isFancyCaptionAsset(asset)) {
        return VideoData.FANCY_CAPTION_ASSET_TYPE;
    }
    throw new Error(`copyAssetToContainer: unsupported asset type for ${asset.name}`);
}

function addStickerToTargetContainer(targetContainer: Scene | AssetGroup, assetType: AssetType) {
    return targetContainer.addSticker(assetType);
}

export function copyAssetToContainerAsSticker(
    sourceAsset: Asset,
    targetContainer: Scene | AssetGroup,
): Asset {
    if (VideoData.isAssetGroup(sourceAsset)) {
        const newGroup = addStickerToTargetContainer(
            targetContainer,
            VideoData.GROUP_ASSET_TYPE,
        ) as AssetGroup;
        sourceAsset.getAssets({ deep: false }).forEach((child) => {
            copyAssetToContainerAsSticker(child, newGroup);
        });
        newGroup.loadAsSticker(sourceAsset.save());

        newGroup.generateNewId();
        return newGroup;
    }

    const data = sourceAsset.save();
    const assetType = getAssetTypeForCopy(sourceAsset);

    const newAsset = addStickerToTargetContainer(targetContainer, assetType);
    newAsset.loadAsSticker(data);
    newAsset.generateNewId();
    return newAsset;
}
